<div class="bigBanner">
  <ngx-slick-carousel *ngIf="router.url !== '/asistente-virtual'" class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
    (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
    
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
      <a *ngIf="slide.url" href="{{ slide.url }}">
        <img src="{{ slide.img }}" alt="" width="100%" [hidden]="slide.hidden" alt="{{ slide.alt }}">
      </a>
      <img *ngIf="!slide.url" src="{{ slide.img }}" alt="" width="100%" [hidden]="slide.hidden" alt="{{ slide.alt }}">
    </div>


  </ngx-slick-carousel>
  <ngx-slick-carousel *ngIf="router.url === '/asistente-virtual'" class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
                      (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
    <div ngxSlickItem  class="slide">
      <img src="{{imagenAsistente}}" alt="" width="100%"  alt="Asistente Online">
    </div>
  </ngx-slick-carousel>
  <div class="scroll">
    <img *ngIf="router.url !== '/beneficio-clientes-vulnerables-covid19' && router.url !== '/beneficio-covid19' && router.url !== '/asistente-virtual'" src="./assets/img/scroll.png" alt="Scroll" />
    <img *ngIf="router.url === '/beneficio-clientes-vulnerables-covid19' || router.url === '/beneficio-covid19'" src="./assets/img/llama.png" alt="Scroll" />
  </div>
</div>